<template lang="pug">
section
  div
    | You must (before, during and after
    | you are granted a sponsor licence):

  br

  ul
    li
      | have HR and recruitment systems
      | in place to meet, or continue
      | to meet your sponsor duties;
    li
      | ensure the Home Office is able to visit
      | and conduct checks to verify
      | that the sponsor duties
      | are being complied with;
    li
      | offer a genuine employment skilled
      | to level RQF3 or above
      | and appropriate rates of pay;
    li
      | appoint key personnel
      | that don’t have unspent criminal conviction
      | or any criminal prosecutions pending;
    li
      | have no previous sponsorship non-compliance
      | (e.g. by owner, director, key personnel
      | involved in your day-to-day running).
</template>

<script>
export default {
  name: "criteria_suitability",
};
</script>